module.exports = __webpack_public_path__ + "static/media/home.cd414867.svg";